import React from 'react';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section id="home" className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-[#050a14]" data-id="element-74">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-75">
        {/* Dark overlay with gradient */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#050a14] via-[#0a1628] to-[#050a14] z-0" data-id="element-76"></div>

        {/* Animated Orbs */}
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-blue-600/20 rounded-full blur-[100px] animate-float opacity-60" data-id="element-77"></div>
        <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] bg-[#f59e0b]/10 rounded-full blur-[120px] animate-float delay-700 opacity-50" data-id="element-78"></div>
        <div className="absolute top-[40%] left-[20%] w-[300px] h-[300px] bg-purple-500/10 rounded-full blur-[80px] animate-pulse opacity-40" data-id="element-79"></div>

        {/* Grid Pattern */}
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-soft-light" data-id="element-80"></div>
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:50px_50px] [mask-image:radial-gradient(ellipse_at_center,black_40%,transparent_80%)]" data-id="element-81"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-82">
        <div className="max-w-4xl mx-auto text-center md:text-left" data-id="element-83">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 backdrop-blur-sm mb-8 animate-fade-in" data-id="element-84">
            <span className="w-2 h-2 rounded-full bg-[#f59e0b] animate-pulse" data-id="element-85"></span>
            <span className="text-sm text-gray-300 font-medium tracking-wide" data-id="element-86">
              Pioneering the Future of Tech
            </span>
          </div>

          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white leading-tight mb-8 animate-slide-up delay-100" data-id="element-87">
            Turning Digital <br data-id="element-88" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white via-blue-200 to-gray-400" data-id="element-89">
              Dreams into
            </span>{' '}
            <br data-id="element-90" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#f59e0b] to-[#d97706] text-glow" data-id="element-91">
              Reality
            </span>
          </h1>

          <p className="text-gray-300 text-lg md:text-xl leading-relaxed mb-10 max-w-2xl animate-slide-up delay-200 md:mx-0 mx-auto" data-id="element-92">
            Welcome to Nawat Tech. We reshape the UAE tech landscape with
            innovative
            <span className="text-white font-semibold" data-id="element-93"> AI</span> and
            <span className="text-white font-semibold" data-id="element-94">
              {' '}
              Cybersecurity
            </span>{' '}
            solutions. Your partner in navigating the digital frontier.
          </p>

          <div className="flex flex-col sm:flex-row gap-5 animate-slide-up delay-300 justify-center md:justify-start" data-id="element-95">
            <a href="#services" className="group relative inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-[#f59e0b] to-[#d97706] text-white font-bold rounded-xl overflow-hidden transition-all hover:shadow-[0_0_30px_rgba(245,158,11,0.6)] hover:scale-105 duration-300" data-id="element-96">
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700" data-id="element-97"></div>
              <span className="relative z-10 flex items-center" data-id="element-98">
                Explore Services
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-99" />
              </span>
            </a>
            <a href="#contact" className="inline-flex items-center justify-center px-8 py-4 bg-white/5 border-2 border-white/20 hover:bg-white/10 hover:border-[#f59e0b] backdrop-blur-sm text-white font-bold rounded-xl transition-all duration-300 hover:scale-105" data-id="element-100">
              Contact Us
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <a href="#about" className="absolute bottom-10 left-1/2 transform -translate-x-1/2 flex flex-col items-center gap-2 text-white/40 hover:text-white/60 transition-colors group cursor-pointer" data-id="element-101">
        <span className="text-xs uppercase tracking-widest font-medium" data-id="element-102">
          Scroll
        </span>
        <div className="w-6 h-10 border-2 border-white/20 rounded-full flex items-start justify-center p-2 group-hover:border-white/40 transition-colors" data-id="element-103">
          <div className="w-1.5 h-3 bg-white/40 rounded-full animate-bounce" data-id="element-104"></div>
        </div>
      </a>
    </section>;
}